import React from 'react'
import { PdfCard, PdfCardWhite } from '../component/pdf.c.card'
import { cn } from '../../../utils/useFunctions'
import { STYLE_PDF_TEXT_MEDIUM_13, STYLE_PDF_TEXT_NORMAL_BLUE_13 } from '../styles/pdf.style'
import SheildCheckIcon from '../../../components/icon/sheildCheckIcon'

const InsuranceNumber = ({InsuranceLife,InsuranceAccident,Insurancecar,InsuranceHome,InsuranceFire}) => {
  return (
    <PdfCard className={"flex flex-col space-y-3"}>
        <PdfCardWhite className={cn("px-[10px] py-[5px]")}>
          <div className="flex w-full space-x-[10px]">
            <div className="flex flex-col w-full h-full ">
              <div className="flex justify-between">
                {" "}
                <div
                  className={cn(STYLE_PDF_TEXT_MEDIUM_13, {
                    "flex font-[600] text-[10px]": true,
                  })}
                >
                  <SheildCheckIcon />
                  <div className="ml-[5px]">ประกันชีวิตที่คุณมี</div>
                </div>{" "}
                <div
                  className={cn(STYLE_PDF_TEXT_NORMAL_BLUE_13, {
                    "flex font-[600] text-[10px] ": true,
                  })}
                >{`${InsuranceLife?.length||0} เล่ม`}</div>
              </div>
              <div className="flex justify-between">
                {" "}
                <div
                  className={cn(STYLE_PDF_TEXT_MEDIUM_13, {
                    "flex font-[600] text-[10px]": true,
                  })}
                >
                  <SheildCheckIcon />
                  <div className="ml-[5px]">ประกันอุบัตเหตุที่คุณมี </div>
                </div>{" "}
                <div
                  className={cn(STYLE_PDF_TEXT_NORMAL_BLUE_13, {
                    " font-[600] text-[10px] ": true,
                  })}
                >{`${InsuranceAccident?.length||0} เล่ม`}</div>
              </div>
              <div className="flex justify-between">
                {" "}
                <div
                  className={cn(STYLE_PDF_TEXT_MEDIUM_13, {
                    "flex font-[600] text-[10px]": true,
                  })}
                >
                  <SheildCheckIcon />
                  <div className="ml-[5px]">ประกันรถยนต์ที่คุณมี</div>
                </div>{" "}
                <div
                  className={cn(STYLE_PDF_TEXT_NORMAL_BLUE_13, {
                    " font-[600] text-[10px] ": true,
                  })}
                >{`${Insurancecar?.length||0} เล่ม`}</div>
              </div>
            </div>

            <div className="flex flex-col w-full h-full ">
              <div className="flex justify-between">
                {" "}
                <div
                  className={cn(STYLE_PDF_TEXT_MEDIUM_13, {
                    "flex font-[600] text-[10px]": true,
                  })}
                >
                  <SheildCheckIcon />
                  <div className="ml-[5px]">ประกันบ้านที่คุณมี </div>
                </div>{" "}
                <div
                  className={cn(STYLE_PDF_TEXT_NORMAL_BLUE_13, {
                    " font-[600] text-[10px] ": true,
                  })}
                >{`${InsuranceHome?.length||0} เล่ม`}</div>
              </div>
              <div className="flex justify-between">
                {" "}
                <div
                  className={cn(STYLE_PDF_TEXT_MEDIUM_13, {
                    "flex font-[600] text-[10px]": true,
                  })}
                >
                  <SheildCheckIcon />
                  <div className="ml-[5px]">ประกันอัคคีภัยที่คุณมี</div>
                </div>{" "}
                <div
                  className={cn(STYLE_PDF_TEXT_NORMAL_BLUE_13, {
                    " font-[600] text-[10px] ": true,
                  })}
                >{`${InsuranceFire?.length||0} เล่ม`}</div>
              </div>
            </div>
          </div>
        </PdfCardWhite>
      </PdfCard>
  )
}

export default InsuranceNumber